var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "sidenav-item",
    class: {
      'open': _vm.isMenuOpen()
    }
  }, [_c('a', {
    staticClass: "sidenav-link sidenav-toggle",
    style: [_vm.isMenuOpen() ? {
      'color': '#e84c64'
    } : {}],
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_c('i', {
    staticClass: "sidenav-icon fa fa-folder-open"
  }), _vm._v(" "), _c('div', [_vm._t("link-text", function () {
    return [_vm._v(_vm._s(_vm.menuData.title))];
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "sidenav-menu"
  }, [_vm._t("menu-items", function () {
    return [_vm._l(_vm.reports, function (child) {
      return [_c('ReportMenuItem', {
        key: child.title,
        attrs: {
          "child": child,
          "show_favorite_button": _vm.show_favorite_button
        },
        on: {
          "favorite_reports_changed": function favorite_reports_changed($event) {
            return _vm.favorite_reports_changed();
          }
        }
      })];
    })];
  })], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }